import { render, staticRenderFns } from "./WizardHeader.vue?vue&type=template&id=1570f3b2"
import script from "./WizardHeader.vue?vue&type=script&lang=js"
export * from "./WizardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports